/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Response } from '../../models/response';

export interface ApiCartCartLinesCartLineIdDelete$Plain$Params {
  cartLineId: string;
}

export function apiCartCartLinesCartLineIdDelete$Plain(http: HttpClient, rootUrl: string, params: ApiCartCartLinesCartLineIdDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
  const rb = new RequestBuilder(rootUrl, apiCartCartLinesCartLineIdDelete$Plain.PATH, 'delete');
  if (params) {
    rb.path('cartLineId', params.cartLineId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Response>;
    })
  );
}

apiCartCartLinesCartLineIdDelete$Plain.PATH = '/api/cart/cart/lines/{cartLineId}';
